import MethodReducerGenerator from './MethodReducerGenerator'

export default class BatchDestroyReducerGenerator extends MethodReducerGenerator {
  constructor(name, basePath) {
    super('BATCHDESTROY', name, basePath)
  }

  static initialState = {
    requestInProgress: false,
    requestComplete: false,
    deleted: false,
    generalError: undefined,
    resourceErrors: undefined,
    attributes: undefined,
    responseHeaders: undefined
  }

  requestHandler(state, action) {
    return { ...state,
      requestInProgress: true,
      requestComplete: false,
      deleted: false,
      attributes: action.attributes }
  }

  responseHandler(state, action) {
    return { ...state,
      requestInProgress: false,
      requestComplete: true,
      deleted: true,
      responseHeaders: action.responseHeaders }
  }

  errorHandler(state, action) {
    return { ...state,
      requestInProgress: false,
      requestComplete: true,
      deleted: false,
      generalError: action.generalError,
      resourceErrors: action.resourceErrors }
  }
}
